var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeamImg2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 182,
  height: 182,
  viewBox: "0 0 182 182"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 91,
  r: 91,
  fill: "#7654fd",
  "data-name": "Ellipse 5"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f0f0f0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m71.922 106.253 18.092-28.734a2.684 2.684 0 0 1 4.257 0l18.091 28.734Z",
  "data-name": "Path 253"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.923 106.252h-7.45l7.982-14.367 4.629 6.172",
  "data-name": "Path 254"
}), /*#__PURE__*/React.createElement("path", {
  d: "m81.417 91.172 4.974 4.238a2.13 2.13 0 0 0 2.88-.119l1.366-1.366a2.13 2.13 0 0 1 3.01 0l1.366 1.366a2.13 2.13 0 0 0 2.88.119l5.008-4.184",
  "data-name": "Path 255"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.61 76.535V58.363",
  "data-name": "Path 256"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.61 58.363h7.982v3.192h9.578l-3.193 4.789 3.193 4.789h-9.578v-1.6H91.61",
  "data-name": "Path 257"
}))));
export default SvgTeamImg2;